<template>
    <div v-if="Object.keys(vehicle.overlapping).length">
        <template v-if="areSame">
            <template v-if="vehicle.overlapping.ends">
                <small class="text-danger">
                    {{ $t('Booked by the next customer from') }} {{ vehicle.overlapping.ends.start_time | formatDateTime }}
                    <br>
                </small>
            </template>
            <template v-if="vehicle.overlapping.starts">
                <small class="text-danger">
                    {{ $t('Returned by the previous customer') }} {{ vehicle.overlapping.starts.end_time | formatDateTime }}
                    <br>
                </small>
            </template>
        </template>
        <template v-else>
            <template v-if="vehicle.overlapping.starts">
                <small class="text-danger">
                    {{ $t('Returned by the previous customer') }} {{ vehicle.overlapping.starts.end_time | formatDateTime }}
                    <br>
                </small>
            </template>
            <template v-if="vehicle.overlapping.ends">
                <small class="text-danger">
                    {{ $t('Booked by the next customer from') }} {{ vehicle.overlapping.ends.start_time | formatDateTime }}
                    <br>
                </small>
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: 'AppOverlapping',
    props: {
        vehicle: Object
    },
    computed: {
        areSame() {
            if (this.vehicle.overlapping.ends == null || this.vehicle.overlapping.starts == null) {
                return false;
            }
            return this.vehicle.overlapping.ends.id == this.vehicle.overlapping.starts.id;
        }
    }
};
</script>
